var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","width":5,"size":100}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }